import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMale, faFemale } from '@fortawesome/free-solid-svg-icons';
import styles from './StrokeContainer.module.css';

const StrokeContainer = ({ children, title, stroke = true }) => {
    let classContainer = stroke === true ? `${styles.container} ${styles.containerStroke}`: styles.container;

    return (
        <div className={classContainer}>
            {stroke ? <h3 className={styles.title}>{title}</h3> : null}
            <div className={styles.twoColLay}>
                {children}
            </div>
        </div>
    );
};

export default StrokeContainer;
